import { withDecoded } from "./";
import { Logo, LogoArrayCodec } from "../store/logo/types";
import { fetch as fetchApi, isString } from "./api";

const LOGOS = "terminalLogos";

function mapToModel(data: any): Logo[] {
  return withDecoded(LogoArrayCodec, data.logos, (decoded) => decoded);
}

export async function getAll(): Promise<Logo[]> {
  return fetchApi({
    nestedResourcePath: [LOGOS],
    id: null,
    params: null
  }).then((response) => {
    try {
      const data =
        isString(response.data) ? JSON.parse(response.data) : response.data;
      return mapToModel(data);
    } catch (e) {
      console.log("error interpretting logo data ", response.data);
      return [];
    }
  });
}
